<template>
	<div :class="status" class="destinations">
		<div class="destinations-from">
			<div class="destinations-from-inner"/>
		</div>
		<div class="destinations-from-content">
			<slot name="from"/>
		</div>

		<div class="destinations-to">
			<div class="destinations-to-inner"/>
		</div>
		<div class="destinations-to-content">
			<slot name="to"/>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TDestinationsLarge',
	props: { status: { type: String, } }
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';

@mixin dot($color, $size, $centerX: false) {
	content: '';
	position: absolute;
	$half: $size / 2;
	$center: calc(50% - #{$half}px);
	top: $center;
	height: #{$size}px;
	width: #{$size}px;
	background-color: $color;
	border-radius: 100%;
	@if $centerX {
		left: $center;
	}
}

@mixin line($color, $size, $direction) {
	content: '';
	position: absolute;
	width: #{$size}px;
	background-color: $color;
	height: 50%;
	$half: $size / 2;
	$center: calc(50% - #{$half}px);
	left: $center;
	@if $direction == 'up' {
		top: 0;
	} @else {
		bottom: 0;
	}
}

.destinations {
	display: grid;
	column-gap: 20px;
	grid-template-columns: 20px auto;
	grid-template-rows: repeat(2, minmax(min-content, max-content));
	align-items: center;
}

.destinations-from-content, .destinations-to-content {
	display: grid;
	column-gap: 20px;
	grid-auto-columns: minmax(0, 1fr);
	grid-auto-flow: column;
	padding: 5px 0px;
}

.destinations-from, .destinations-to, .destinations-from-inner, .destinations-to-inner {
	position: relative;
	height: 100%;
}

.destinations-from-inner, .destinations-to-inner {
	z-index: 2;
}

.destinations-from-inner:before, .destinations-to-inner:before {
	@include dot(#c7ced4, 12, true);
}

.destinations-from:before, .destinations-to:before {
	@include dot(#edf0f2, 20);
}

.destinations-from:after {
	@include line(#edf0f2, 4, 'down');
}

.destinations-to:after {
	@include line(#edf0f2, 4, 'up');
}

.started {
	.destinations-from .destinations-from-inner:after {
		@include line(get-color($green), 2, 'down');
	}

	.destinations-from .destinations-from-inner:before {
		@include dot(get-color($green), 12, true);
	}
}

.completed {
	.destinations-from .destinations-from-inner:after {
		@include line(get-color($neutral), 2, 'down');
	}

	.destinations-to .destinations-to-inner:after {
		@include line(get-color($neutral), 2, 'up');
	}

	.destinations-from .destinations-from-inner:before, .destinations-to .destinations-to-inner:before {
		@include dot(get-color($neutral), 12, true);
	}
}
</style>

/* eslint-disable */
<docs>
	```jsx noeditor
	new Vue({
		data(){
			return {
				statuses: ['ready', 'started', 'completed'],
				status: 'ready'
			};
		},
		template: `
		<div style="width:500px; display: grid; row-gap: 20px;">
			<t-select width="150px" :selectedItem="status" :items="statuses" @change="status = $event" />
			<t-destinations-large :status="status">
				<template v-slot:from>
					<t-details-item label="from" primary="Terminal Tiller" secondary="7038 Tiller" />
					<t-details-item label="consignor" primary="Last Shipping AS" />
					<t-details-item label="DEPARTURE" primary="08.01.2019" />
				</template>
				<template v-slot:to>
					<t-details-item label="from" primary="Terminal Ålesund" secondary="6001 Ålesund" />
					<t-details-item label="consignee" primary="Timpex AS" />
					<t-details-item label="ARRIVAL " primary="22.01.2019" />
				</template>
			</t-destinations-large>
		</div>
		`
	});
	```
	```html
	<div style="width:500px">
	<t-destinations-large>
		<template v-slot:from>
			<t-details-item label="from" primary="Terminal Tiller" secondary="7038 Tiller" />
			<t-details-item label="consignor" primary="Last Shipping AS" />
			<t-details-item label="DEPARTURE" primary="08.01.2019" />
		</template>
		<template v-slot:to>
			<t-details-item label="from" primary="Terminal Ålesund" secondary="6001 Ålesund" />
			<t-details-item label="consignee" primary="Timpex AS" />
			<t-details-item label="ARRIVAL " primary="22.01.2019" />
		</template>
	</t-destinations-large>
	</div>
	```
</docs>
/* eslint-enable */